import React from 'react';
import { useTranslation } from 'react-i18next';

function RecyclingInfo({ isMobile }) {
  const { t, i18n } = useTranslation();

  const lang = i18n.language;
  const recycleUrl =
    lang === 'en'
      ? 'https://sukui-wear.jp/en/pages/recycle.html'
      : 'https://sukui-wear.jp/pages/recycle.html';

  return (
    <div className={`recycling-container ${isMobile ? 'recycling-footer' : 'recycling-info'}`}>
      <div className="recycling-content">
        {/* アイコンをPC表示のみに表示 */}
        {!isMobile && (
          <img
            src="/images/icon/icon_recycle.svg"
            alt={t('recyclingInfo.iconAlt')}
            width="20"
            height="20"
            className="recycling-icon"
          />
        )}
        <p className="recycling-text">
          {t('recyclingInfo.description')}
        </p>

        {/* モバイル用リンク */}
        {isMobile ? (
          <a
            href={recycleUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="recycling-details"
          >
            {t('recyclingInfo.detailsLink')}
            <span className="icon-arrow-right">
              <img
                src="/images/icon/icon_arrow_right.svg"
                alt={t('recyclingInfo.detailsLink')}
                width="15"
                height="15"
              />
            </span>
          </a>
        ) : null}
      </div>

      {/* PC用リンク */}
      {!isMobile && (
        <a
          href={recycleUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="recycling-details"
        >
          {t('recyclingInfo.detailsLink')}
          <span className="icon-arrow-right">
            <img
              src="/images/icon/icon_arrow_right.svg"
              alt={t('recyclingInfo.detailsLink')}
              width="15"
              height="15"
            />
          </span>
        </a>
      )}
    </div>
  );
}

export default RecyclingInfo;
